import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { membersService } from '../api/members.service';
import { MEMBERS_KEYS } from './queryKeys';
import type { SetMemberHireDatePayload } from '../types';

/**
 * Sets a member's hire date. Owner/Admin only (enforced server-side).
 * Calls PUT /api/tenants/members/{userId}/hire-date.
 */
export function useSetMemberHireDate() {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useMutation({
    mutationFn: ({ userId, payload }: { userId: string; payload: SetMemberHireDatePayload }) =>
      membersService.setHireDate(userId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MEMBERS_KEYS.byOrg(orgId) });
    },
  });
}
